import { render, staticRenderFns } from "./PaymentOptions.vue?vue&type=template&id=edada270&scoped=true"
import script from "./PaymentOptions.vue?vue&type=script&lang=js"
export * from "./PaymentOptions.vue?vue&type=script&lang=js"
import style0 from "./PaymentOptions.vue?vue&type=style&index=0&id=edada270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edada270",
  null
  
)

export default component.exports